<div class="row" class="row border Page-Header">
    <div class="col-12 p-0">
      <h6 class="HeadContent">Study Unit - Study Material Report</h6>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
        <div class="row">
            <div class="col-10">
                <div class="row">
                    <div class="col-12">
                        <form [formGroup]="StudyMaterialReportform">
                            <div class="row pt-2">
                                <div class="col-4">
                                    <select class="form-control form-control-sm" formControlName="SubjectID"
                                    (change)="SelectSubject($event)">
                                    <option selected value="" hidden>Select Subject</option>
                                    <option class="border-bottom" *ngFor="let s of subject;let i=index" [value]="s.ID"> {{s.Name}}</option>
                                  </select>

                                </div>
                                <div class="col-4">
                                    <select class="form-control form-control-sm" formControlName="MajorTopicID"
                                    >
                                    <option selected value="" hidden>Select Major Topic</option>
                                    <option class="border-bottom" *ngFor="let MT of MajorTopic;let i=index" [value]="MT.ID">{{MT.Name}}</option>
                                    </select>
                            </div>
                            <div class="col-4">
                                <div class="d-flex">
                                    <div class="px-0">
                                      <button type="button"  class="btn btn-sm bl-btn" [disabled]="!StudyMaterialReportform.value.SubjectID" (click)="Fetchreports()">Run</button>
                                    </div>
                                  </div>

                        </div>

                            </div>
                        </form>
                    </div>

                </div>

            </div>
            <div class="col-2">
                <div class="row">
                    <div class="col-12">

                    </div>

                </div>
            </div>

        </div>
        <div class="row pt-2">
            <div class="col-12 scroll-style">
                <table id="sortTable" class="table  table-sm table-bordered border-secondary table-hover table-responsive">
                    <thead>
                      <tr class="table-secondary table-bordered border-secondary">
                        <th rowspan="2" class="col-md-3 middle">Study Unit</th>
                        <th colspan="7" class="middle">Study Materials</th>
                        <!-- <th rowspan="2">Subject</th> -->
                        <th rowspan="2" class="col-md-3 middle">Major Topic</th>
                        <th rowspan="2" class="col-md-3 middle">Concept</th>
                        <th rowspan="2" class="col-md-3 middle">SCL1</th>
                        <th rowspan="2" class="col-md-2 middle">SCL2</th>
                        <th rowspan="2" class="middle">SCL3</th>
                        <th rowspan="2" class="middle">SCL4</th>
                        <th rowspan="2" class="middle">SCL5</th>
                        <th rowspan="2" class="middle">SCL6</th>
                      </tr>
                      <tr class="table-secondary table-bordered border-secondary">
                        <th scope="col" class="middle">Approved</th>
                        <th scope="col" class="middle">WIP</th>
                        <th scope="col" class="middle">Submitted</th>
                        <th scope="col" class="middle">Under Review</th>
                        <th scope="col" class="middle">Rework</th>
                        <th scope="col" class="middle">Deferred</th>
                        <th scope="col" class="middle">Rejected</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr class="middle2" *ngFor="let s of getreport;let i=index">
                        <td class="col-md-3 middle2">{{s.Study_Unit_Name}}</td>
                        <td class='link middle1'  (click)="s.Approved > 0 && Clickvalue(s,'Approved',s.Approved)">{{s.Approved}}</td>
                        <td class='link middle1' (click)="s.WIP > 0 && Clickvalue(s,'WIP',s.WIP)">{{s.WIP}}</td>
                        <td class='link middle1' (click)="s.Submitted > 0 && Clickvalue(s,'Submitted',s.Submitted)">{{s.Submitted}}</td>
                        <td class='link middle1' (click)="s.Under_Review > 0 && Clickvalue(s,'Under Review',s.Under_Review)">{{s.Under_Review}}</td>
                        <td class='link middle1' (click)="s.Rework > 0 && Clickvalue(s,'Rework',s.Rework)">{{s.Rework}}</td>
                        <td class='link middle1' (click)="s.Defer > 0 && Clickvalue(s,'Defer',s.Defer)">{{s.Defer}}</td>
                        <td class='link middle1' (click)="s.Rejected > 0 && Clickvalue(s,'Rejected',s.Rejected)">{{s.Rejected}}</td>
                        <!-- <td>{{s.Subject_Name}}</td> -->
                        <td class="col-md-3 middle2">{{s.Major_Topic_Name}}</td>
                        <td class="col-md-3">{{s.Concept_Name}}</td>
                        <td class="col-md-3">{{s.SCL1_Name}}</td>
                        <td class="col-md-2">{{s.SCL2_Name}}</td>
                        <td>{{s.SCL3_Name}}</td>
                        <td>{{s.SCL4_Name}}</td>
                        <td>{{s.SCL5_Name}}</td>
                        <td>{{s.SCL6_Name}}</td>
                      </tr>
                    </tbody>
                  </table>
            </div>

        </div>


    </div>
  </div>
  <div class="modal fade  show Model_popup1" *ngIf="ActivityHistorypopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Activity History</h6>
          <button type="button" class="close" (click)="Activityhistorypopup()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
            <div class="row pt-2">
                <div class="col-12 scroll-style1">
                  <table id="table" class="table  table-sm table-bordered table-hover">
                    <thead>
                      <tr class="table-secondary">
                        <th class="col-md-3 middle">Subject</th>
                        <th class="col-md-3 middle">Study Unit</th>
                        <th class="col-md-3 middle">Study Material</th>
                        <th class="col-md-1 middle">Creation Date</th>
                        <th class="col-md-2 middle">Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let s of ActivityHistorylist;let i=index">
                        <td>{{s.Subject_Name}}</td>
                        <td>{{s.Study_Unit_Name}}</td>
                        <td  class='link' (click)="EditButton(s)">{{s.Study_Material_Name}}</td>
                        <td>{{s.Creation_Date  | date: "dd/MM/yy" }}</td>
                        <td class='link' title="Status History" (click)="clickstatuspopup(s.Study_Material_Id)">{{s.Study_Material_Status_Type_Name}}</td>
                        <!-- <br /><div class='link' (click)="clickstatuspopup(s.Study_Material_Id)">Status History</div> -->
                      </tr>
                    </tbody>
                  </table>
                  <div class="col-12">
                    <div class="d-flex justify-content-center pt-1 pb-1">

                      <div class="px-1">
                        <button type="button" class="btn btn-sm bg-light border" (click)="Activityhistorypopup()">Close</button>

                      </div>
                    </div>
                  </div>

          </div>
        </div>

        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show Model_popup1" *ngIf="statuspopupflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Status History</h6>
          <button type="button" class="close" (click)="statuslistpopup()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">
         <app-content-studymaterial-statuslist (returnstatusclose)="returnstatusclose($event)"[Selectedstudymaterial]="Selectedstudymaterial"></app-content-studymaterial-statuslist>

        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show Model_popup1" *ngIf="EditStudyMaterialflag">
    <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Study Material</h6>
          <button type="button" class="close" (click)="CloseEditStudyMaterial(1)"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">

        <app-content-add-edit-studymaterial [Closeclear]="Closeclear" [Replaceclear]="Replaceclear"  [Close1]="Close1" [Replace1]="Replace1"  (CloseEditStudyMaterial)="CloseEditStudyMaterial($event)" (Editstudymaterial)="Editstudymaterial($event)" [ScreenName1]="ScreenName1" (ClickContentstatus)="ClickContentstatus($event)" (contentreview)="contentreview($event)" (contentpreview)="contentpreview($event)" (CloseandRefreshlist)="CloseandRefreshlist($event)" [CurrentstudyunitID]="CurrentstudyunitID" [Replace]="Replace" [Close]="Close" (ReplaceAlertPopup)="ReplaceAlertPopup($event)" (AlertPopup)="AlertPopup($event)" [EditStudyMaterialflag]="EditStudyMaterialflag" [StudyMaterialDetails]="StudyMaterialDetails" ></app-content-add-edit-studymaterial>
        </div>
      </div>
    </div>
    <div class="modal fade  show Model_popup1" *ngIf="Contentreviewpopupflag">
      <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
        <div class="modal-content">
          <div class="modal-header border Page-Header p-1 py-0">
            <h6 class="HeadContent" id="QuestionTemplatetitle">Review {{Contentstatus}} Content</h6>
            <button type="button" class="close" (click)="ClkContentclose()"
              style="padding-right: 20px;font-size: 30px;outline: 0;">
              <span aria-hidden="true">&times;</span></button>
          </div>

          <div class="modal-body px-3 py-0">
            <app-content-for-review [ScreenName1]="ScreenName1" (CloseandRefreshlist)="CloseandRefreshlist($event)" (returnreviewpopup)="returnreviewpopup($event)" (ReturnContentreviewclose)="ReturnContentreviewclose($event)" [Contenttext]="Contenttext" [Contentstatus]="Contentstatus" [selectedContentById]="selectedContentById" ></app-content-for-review>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show Model_popup1" *ngIf="previewpopupflag">
    <div class="modal-dialog modal-dialog-centered  modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Preview Study Material</h6>
          <button type="button" class="close" [disabled]='validclosebutton'(click)="Closepreview()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">

          <app-content-preview (returnclosebutton)="returnclosebutton($event)" [ScreenName1]="ScreenName1" (ClickContentstatus)="ClickContentstatus($event)" [StudymaterialFormvalue]="StudymaterialFormvalue" [studymateriallist]="studymateriallist" ></app-content-preview>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade  show Model_popup1" *ngIf="reviewpopupflag">
    <div class="modal-dialog modal-dialog-centered  modal-dialog-Question-add">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Review Content</h6>
          <button type="button" class="close" [disabled]='validclosebutton'(click)="CloseReviewContent()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0">

          <app-content-reviewcomments (ClickContentstatus)="ClickContentstatus($event)"(returnreviewclosebutton)="returnreviewclosebutton($event)" [ScreenName1]="ScreenName1"  [StudymaterialFormvalue1]="StudymaterialFormvalue1" [studymateriallist1]="studymateriallist1" ></app-content-reviewcomments>

        </div>
      </div>
    </div>
    <div class="modal fade  show Model_popup1" *ngIf="Contentreviewpopupflag">
      <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
        <div class="modal-content">
          <div class="modal-header border Page-Header p-1 py-0">
            <h6 class="HeadContent" id="QuestionTemplatetitle">Review {{Contentstatus}} Content</h6>
            <button type="button" class="close" (click)="ClkContentclose()"
              style="padding-right: 20px;font-size: 30px;outline: 0;">
              <span aria-hidden="true">&times;</span></button>
          </div>

          <div class="modal-body px-3 py-0">
            <app-content-for-review [ScreenName1]="ScreenName1" (CloseandRefreshlist)="CloseandRefreshlist($event)" (returnreviewpopup)="returnreviewpopup($event)" (ReturnContentreviewclose)="ReturnContentreviewclose($event)" [Contenttext]="Contenttext" [Contentstatus]="Contentstatus" [selectedContentById]="selectedContentById" ></app-content-for-review>

          </div>
        </div>
      </div>
    </div>

  </div>
